import React, { Fragment, useState } from "react";
// import styled from "styled-components";

import { Textarea } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import { CheckboxLabel, CheckboxInput } from "components/CheckboxLabel";

import { formPropTypes } from "./prop-types";
import {
  Title,
  StyledP2,
  FormPartial,
  Input,
  Range,
  RangeLabel,
} from "../styles";

const rangeValues = ["Slow (<7kW)", "Fast (7kW–22kW)", "Rapid (>22kW)"];

export const MajorElectricalLoadsForm = ({ base }) => {
  const [hasEVCharger, setHasEVCharger] = useState(false);
  const [hasOther, setHasOther] = useState(false);
  const [chargeRange, setChargerRange] = useState(0);

  return (
    <Fragment>
      <Title>Major Electrical Loads</Title>
      <StyledP2>
        Please indicate which energy-intensive appliances you’d like to continue
        to work during a power outage.
      </StyledP2>
      <FormPartial
        css={`
          grid-row-gap: unset;
          padding: 0px;
          > input {
            margin: 6px 1em 10px calc(22px + 1em);
          }
          > label {
            padding: 4px 0px;
          }
        `}
      >
        <CheckboxLabel>
          <CheckboxInput name={base("ElectricHeat")} type="checkbox" />
          <span>{"Electric Heat"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("Ac")} type="checkbox" />
          <span>{"AC"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("PoolHeater")} type="checkbox" />
          <span>{"Pool Heater"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("SumpPump")} type="checkbox" />
          <span>{"Sump Pump"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("ElectricWaterHeater")} type="checkbox" />
          <span>{"Electric Water Heater"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("Freezers")} type="checkbox" />
          <span>{"Freezer(s)"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("PoolPump")} type="checkbox" />
          <span>{"Pool Pump"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("EvCharger")}
            onChange={isChecked => setHasEVCharger(isChecked)}
            data-enzyme="ev-checkbox"
          />
          <span>{"EV Charger"}</span>
        </CheckboxLabel>
        <Range
          type="range"
          onChange={e => setChargerRange(e.target.value)}
          name={base("EvChargerRange")}
          value={chargeRange}
          disabled={!hasEVCharger}
          min={0}
          max={rangeValues.length - 1}
          label="Type"
          data-enzyme="ev-range"
        />
        <RangeLabel htmlFor={base("EvChargerRange")}>
          <span className="hideAccessible">{"Range of EV Charger"}</span>
          {rangeValues[chargeRange]}
        </RangeLabel>
        <Input
          name={base("EvChargerRangeValue")}
          type="hidden"
          value={rangeValues[chargeRange]}
        />
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("HaveOtherElectricalLoads")}
            onChange={isChecked => setHasOther(isChecked)}
            data-enzyme="other-checkbox"
          />
          <span>{"Other"}</span>
        </CheckboxLabel>
        <Textarea name={base("OtherElectricalLoads")} disabled={!hasOther} />
        <label
          className="hideAccessible"
          htmlFor={base("OtherElectricalLoads")}
        >
          {"List energy-intensive appliances to use during an outage"}
        </label>
      </FormPartial>
    </Fragment>
  );
};

MajorElectricalLoadsForm.propTypes = formPropTypes;
